import React from "react";

function  AddTextButton(props) {
    // Inline styles for the button
    const buttonStyle = {
        opacity: "0.8",
        backgroundColor: "transparent", // Default background
        borderColor: "#dc3545", // Red border from btn-outline-danger
        color: "#dc3545", // Red text
        marginRight: "10px"
    };

    return (
        <button type="button" className="btn btn-sm photoEditorButton" style={buttonStyle} onClick={props.onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-type" viewBox="0 0 16 16">
                <path d="m2.244 13.081.943-2.803H6.66l.944 2.803H8.86L5.54 3.75H4.322L1 13.081zm2.7-7.923L6.34 9.314H3.51l1.4-4.156zm9.146 7.027h.035v.896h1.128V8.125c0-1.51-1.114-2.345-2.646-2.345-1.736 0-2.59.916-2.666 2.174h1.108c.068-.718.595-1.19 1.517-1.19.971 0 1.518.52 1.518 1.464v.731H12.19c-1.647.007-2.522.8-2.522 2.058 0 1.319.957 2.18 2.345 2.18 1.06 0 1.716-.43 2.078-1.011zm-1.763.035c-.752 0-1.456-.397-1.456-1.244 0-.65.424-1.115 1.408-1.115h1.805v.834c0 .896-.752 1.525-1.757 1.525"/>
            </svg>
        </button>
    );
}

export default AddTextButton;